import type { ReactNode } from "react";
import { useSignupModal } from "@/features/signup/SignupModal";
import { useMaestriaContent } from "@/shared/i18n/LocaleContext";
import { ButtonLink } from "@/shared/components/ButtonLink/ButtonLink";
import styles from "./QuickFacts.module.css";

function withAccent(text: string, accent: string): ReactNode {
  const index = text.indexOf(accent);
  if (index < 0) return text;
  return (
    <>
      {text.slice(0, index)}
      <strong>{accent}</strong>
      {text.slice(index + accent.length)}
    </>
  );
}

export function QuickFacts() {
  const { quickFacts } = useMaestriaContent();
  const openSignup = useSignupModal();

  return (
    <section
      id="atributos"
      className={`maestria-section ${styles.section}`}
      aria-labelledby="quickfacts-title"
    >
      <div className={`maestria-container ${styles.inner}`}>
        <div className={styles.layout}>
          <div className={styles.lead}>
            <h2 id="quickfacts-title" className={styles.leadText}>
              {withAccent(quickFacts.title, quickFacts.titleAccent)}
            </h2>
            <ButtonLink onClick={openSignup} className={styles.cta}>
              {quickFacts.cta.label}
            </ButtonLink>
          </div>
          <ul className={styles.cards}>
            {quickFacts.cards.map((card) => (
              <li key={card.title} className={styles.card}>
                <img src={card.icon} alt="" width={160} height={160} loading="lazy" />
                <h3 className={styles.title}>{card.title}</h3>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
